export default "__VITE_ASSET__tKLhcE2U__"